import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getUnprocessedItems, getOutstandingTotal } from 'helpers/accounting';

import Badge from 'components/v2/Badge';

import { withTranslation } from 'react-i18next';
import formatMoney from 'utils/formatters/Money';
import { Disclosure } from '@headlessui/react';
import { ChevronRightIcon, ChevronUpIcon } from '@heroicons/react/20/solid';
import { featureEnabled, CONFIGURED_FEATURES } from 'helpers/feature-flags';

class ChargeItem extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  getOutstandingTotal() {
    const { ledgerType, shipment } = this.props;
    return getOutstandingTotal(shipment, ledgerType);
  }

  getFormattedTotal() {
    const amount = this.getOutstandingTotal();
    return formatMoney(amount, this.props.currency);
  }

  handleToggleExpand = () => {
    this.setState((prevState) => ({ expanded: !prevState.expanded }));
  };

  render() {
    const { shipment, isEven, t } = this.props;
    const { expanded } = this.state;
    const missingDocsLabel = featureEnabled(CONFIGURED_FEATURES.SSR) ? 'MISSING_DOCS' : 'MISSING_POD';

    const className = classnames({
      'w-full': true,
      'flex-col': true,
      flex: true,
      'text-grey-dark': true,
      'bg-white': !isEven,
      'bg-grey-lightest': isEven,
      'px-2': true,
    });

    const headingClassName = classnames({
      'w-1/2': true,
      'font-bold': true,
      'text-grey-darker': true,
      flex: true,
    });

    return (
      <Disclosure>
        <div className={className}>
          <div className="w-full flex flex-row items-center">
            <div className={headingClassName}>
              <span>{shipment.shipment_id}</span>
              {shipment.missing_docs && (
                <div className="px-2 -mt-0.5">
                  <Badge color="red">{t(missingDocsLabel)}</Badge>
                </div>
              )}
            </div>
            <div className="w-1/4 flex lg:justify-end">
              <div className="w-1/2 md:pl-6">
                {!this.state.expanded && (
                  <span>{this.getFormattedTotal()}</span>
                )}
              </div>
            </div>
            <div className="w-1/4 flex items-center lg:justify-end">
              <Disclosure.Button className="button justify-center flex items-center px-0 m-1">
                {({ open }) => (
                  <>
                    {!open && <ChevronRightIcon className="w-5 h-5" />}
                    {open && <ChevronUpIcon className="w-5 h-5" />}
                  </>
                )}
              </Disclosure.Button>
            </div>
          </div>
          <Disclosure.Panel>
            <Charges {...this.props}>
              <div className="w-full flex justify-between mb-2">
                <span className="font-bold mr-2">{t('TOTAL')}:</span>
                <span>{this.getFormattedTotal()}</span>
              </div>
            </Charges>
          </Disclosure.Panel>
        </div>
      </Disclosure>
    );
  }
}

ChargeItem.propTypes = {
  shipment: PropTypes.object,
  isEven: PropTypes.bool,
  ledgerType: PropTypes.oneOf(['receivables', 'payables']),
};

const Charges = ({ children, shipment, ledgerType, expanded, currency }) => (
  <div className="w-full">
    <div className="charges-wrapper mb-4">
      <div className="bg-white p-2">
        {getUnprocessedItems(shipment, ledgerType).map((adjustment) => (
          <div
            key={adjustment._id}
            className="w-full flex flex-row justify-between my-2 mb-2"
          >
            <div>{adjustment.message}</div>
            <div>{formatMoney(adjustment.value, currency)}</div>
          </div>
        ))}
        <hr className="my-2" />
        {children}
      </div>
    </div>
  </div>
);

Charges.propTypes = {
  expanded: PropTypes.bool,
  shipment: PropTypes.object,
  children: PropTypes.node,
  ledgerType: PropTypes.oneOf(['receivables', 'payables']),
};

export default withTranslation()(ChargeItem);
